import { getLoggedUserInfo } from 'app/utils/globalDataHelpers';
import { getSizeData } from 'app/productDetails/productDetailsUtils';
import {
  getProductData,
  getProductAvailability,
  getLocaleDataByUid,
  getLanguageName,
  clearEcommerceAndPushToDataLayer,
  getProductEcommerceObject,
} from './gtmAnalyticsUtils';
import { dlTrackVirtualPage } from './gtmVirtualPagesAnalytics';
import { DL_EVENT_PROMO_PRODUCT_VIEW_ABTASTY, DL_EVENT_VIEW_ITEM } from './gtmAnalyticsConstants';
import { trackViewAdd } from './advancedCommerceAnalytics';

const { locale, promoAbTastyCategories } = window.inlineGlobalConfig;

export function promoProductViewAbtasty(product) {
  const configuredForLocale = promoAbTastyCategories?.[locale.isoCode];
  if (!configuredForLocale) return;

  const parsedAbTastyCategories = configuredForLocale
    .slice(1, -1)
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);

  const productCategoryCodes = product.superCategoryCodes || [];
  const hasMatch = productCategoryCodes.some(code => parsedAbTastyCategories.includes(code));

  if (!hasMatch) return;

  clearEcommerceAndPushToDataLayer(DL_EVENT_PROMO_PRODUCT_VIEW_ABTASTY, {
    baseProductId: product.productCode,
    category: productCategoryCodes,
    productName: `${product.name} ${product.description}`,
    price: product.price,
  });
}

export function dlViewItem(product) {
  clearEcommerceAndPushToDataLayer(
    DL_EVENT_VIEW_ITEM,
    getProductEcommerceObject({
      ...product,
      product_availability: getProductAvailability(getSizeData(product)) || 0,
    })
  );

  trackViewAdd(product);
}

export function dlTrackLoadedProduct(product) {
  getLoggedUserInfo().then(userInfo => {
    try {
      const productAnalytics = getProductData({
        ...product,
        crossSell: new URL(window.location).searchParams.get('crossSell'),
      });

      const searchQuery = new URL(window.location).searchParams.get('query');

      const dataLayerInfo = {
        event: 'visitor interaction',
        interaction_name: 'product view',
        product_availability: getProductAvailability(getSizeData(product)) || 0,
        user_status: userInfo['userInfo/index']?.username ? 'logged in' : 'not logged in',
        product_finding_method: document.referrer.includes(window.location.host) ? 'navigation link' : 'entry',
        ecommerce: {
          currencyCode: locale.currentCurrency,
          detail: {
            products: [productAnalytics],
          },
        },
        ...(searchQuery ? { search_term: searchQuery } : {}),
      };

      window.dataLayer.push(dataLayerInfo);
    } catch (error) {
      console.error(error);
    }
  });
}

export function dlTrackVirtualProductPage(dataLayerName) {
  const { gaAccount, country, language } = {
    ...getLocaleDataByUid(locale.country),
    language: getLanguageName(locale.language),
  };
  const searchQuery = new URL(window.location).searchParams.get('query');
  dlTrackVirtualPage('', {
    ga_account: gaAccount,
    page_type: 'product',
    page_name: `/ga-virtual${dataLayerName}${searchQuery ? `?text=${searchQuery}` : ''}`,
    site: country,
    language,
  });
}
